import { RISK_ASSOCIATION_KIND } from './utils.js';

export const RISK_FIELD_CYCLE_NAME = 'cycle_name';
export const RISK_FIELD_RISK_DESCRIPTION = 'risk_description';
export const RISK_FIELD_PROCESS_NAME = 'process_name';
export const RISK_FIELD_NODE_DESCRIPTION = 'node_description';
export const RISK_FIELD_RECOMMENDATION = 'recommendation';
export const RISK_FIELD_RISK_LEVEL = 'risk_level';

const RISK_SORT_KEY_RISK_ID = 'risk_id';
const RISK_SORT_KEY_CLIENT_RISK_ID = 'client_risk_id';
const RISK_SORT_KEY_CATEGORY = 'risk_category';
const RISK_SORT_KEY_PROCESS_COUNT = 'process_count';
const RISK_SORT_KEY_CONTROL = 'control';

export const RISK_SORT_KEY = {
  RISK_ID: RISK_SORT_KEY_RISK_ID,
  CLIENT_RISK_ID: RISK_SORT_KEY_CLIENT_RISK_ID,
  RISK_DESCRIPTION: RISK_FIELD_RISK_DESCRIPTION,
  RISK_LEVEL: RISK_FIELD_RISK_LEVEL,
  CATEGORY: RISK_SORT_KEY_CATEGORY,
  PROCESS_NAME: RISK_FIELD_PROCESS_NAME,
  PROCESS_COUNT: RISK_SORT_KEY_PROCESS_COUNT,
  CONTROL: RISK_SORT_KEY_CONTROL,
};

export const RISK_ASSOCIATION_UI = {
  [RISK_ASSOCIATION_KIND.PROCESS]: {
    columnId: 'processes',
    columnLabel: 'Processes',
    headerLabel: 'Processes',
    popoverTitle: 'Linked processes',
    primaryTextKey: 'processDisplayId',
    secondaryTextKey: 'processName',
    actionLabel: 'Go to process',
  },
  [RISK_ASSOCIATION_KIND.CONTROL]: {
    columnId: 'control',
    columnLabel: 'Controls',
    headerLabel: 'Controls',
    popoverTitle: 'Controls by process (RCM pairings)',
    primaryTextKey: 'controlDisplayId',
    secondaryTextKey: 'controlTitle',
    actionLabel: 'Go to control',
  },
};

export const RISK_ASSOCIATION_COLUMN_ORDER = [
  RISK_ASSOCIATION_KIND.PROCESS,
  RISK_ASSOCIATION_KIND.CONTROL,
];

